import { render } from "./Custom.vue?vue&type=template&id=5e371fca&lang=pug"
import script from "./Custom.vue?vue&type=script&lang=js"
export * from "./Custom.vue?vue&type=script&lang=js"

import "./Custom.vue?vue&type=style&index=0&id=5e371fca&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__